import React, { useState, useEffect, useRef } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import CommonDatePicker from '../datepicker/CommonDatePicker';
import 'rsuite/dist/rsuite.min.css';
import { API_URL } from '../Config';
import config from "../common/Config";
import * as XLSX from 'xlsx';

const StockReport = () => {
	const [reportrange, setReportrange] = useState('');
	const [dates, setDates] = useState([null, null]);
	const [categoryOptions, setCategoryOptions] = useState([]);
	const [brandOptions, setBrandOptions] = useState([]);
	const [salescategory, setSalescategory] = useState('');
	const [salesbrand, setSalesbrand] = useState('');
	const [recordsTotal, setRecordsTotal] = useState('');
	const accessToken = localStorage.getItem('accessToken');
	const salesOrderRef = useRef(null);

	const handleDateChange = (value) => {
		setDates(value);
		let formattedStartDate = value[0] ? format(value[0], 'MM/dd/yyyy') : '';
		let formattedEndDate = value[1] ? format(value[1], 'MM/dd/yyyy') : '';
		setReportrange(formattedStartDate ? `${formattedStartDate} - ${formattedEndDate}` : '');
	};

	const fetchCategoriesOptions = async () => {
		try {
			const res = await fetch(`${API_URL}/stock_take/getCategories`, {
				method: 'POST',
				headers: { authorization: `Bearer ${accessToken}` }
			});
			const data = await res.json();
			setCategoryOptions(data.data.category.map(item => ({ value: item.id, label: item.name })));
		} catch (err) {
			console.error('Category fetch failed', err);
		}
	};

	const fetchBrandOptions = async () => {
		try {
			const res = await fetch(`${API_URL}/stock_take/getBrands`, {
				method: 'POST',
				headers: { authorization: `Bearer ${accessToken}` }
			});
			const data = await res.json();
			setBrandOptions(data.data.brands.map(item => ({ value: item.id, label: item.name })));
		} catch (err) {
			console.error('Brand fetch failed', err);
		}
	};

	const fetchReport = () => {
		const $table = $(salesOrderRef.current);
		const searchValue = $('#searchValue').val();

		if ($.fn.DataTable.isDataTable($table)) {
			$table.DataTable().destroy();
		}

		$table.DataTable({
			processing: true,
			serverSide: true,
			ajax: {
				url: `${config.API_URL}/stockReport`,
				type: 'POST',
				headers: {
					authorization: `Bearer ${accessToken}`,
				},
				data: function (d) {
					return $.extend({}, d, {
						draw: d.draw,
						start: d.start,
						length: d.length,
						searchValue,
						reportrange,
						brand_id: salesbrand,
						category_id: salescategory,
					});
				},
				dataSrc: function (json) {
					if (json && Array.isArray(json.data)) {
						$('#totalBoxQty').html(parseFloat(json.BoxQuantity || 0).toFixed(2));
						$('#totalPiecesQty').html(parseFloat(json.PiecesQuantity || 0).toFixed(2));
						let totalAmount = 0;
						if (json.total !== undefined && json.total !== null && json.total !== '') {
							const cleaned = json.total.toString().replace(/,/g, '');
							totalAmount = parseFloat(cleaned);
							if (isNaN(totalAmount)) totalAmount = 0;
						}
						$('#totalAmount').html(totalAmount.toFixed(2));
						setRecordsTotal(json.recordsTotal);
					}
					return json.data || [];
				}
			},
			columns: [
				{ data: null, title: 'Sr. No.', orderable: false, width: '50px' }, // Small width
				{ data: 'product_code', title: 'Code' },
				{ data: 'product_name', title: 'Name' },
				{ data: 'categories', title: 'Category' },
				{ data: 'brand', title: 'Brand' },
				{ data: 'cost', title: 'Cost' },
				{ data: 'pack', title: 'Pack' },
				{ data: 'BoxQuantity', title: 'Total Box Qty' },
				{ data: 'PiecesQuantity', title: 'Total Piece Qty' },
				{
					data: 'total',
					title: 'Total Amount',
					render: (data) => parseFloat(data).toFixed(2)
				}
			],
			columnDefs: [
				{
					targets: 0, // Sr. No.
					orderable: false,
					className: 'text-center',
					width: '50px',
					createdCell: function (td, cellData, rowData, row) {
						$(td).html(row + 1);
					}
				},
				{
					targets: 2, // Name column
					width: '300px' // Wider name column
				}
			],
			pageLength: 50,
		});
	};

	useEffect(() => {
		fetchReport();
		fetchCategoriesOptions();
		fetchBrandOptions();
	}, [reportrange]);

	const exportToExcel = async () => {
		const formData = new FormData();
		formData.append('draw', '1');
		formData.append('start', '0');
		formData.append('length', recordsTotal);
		formData.append('reportrange', reportrange);
		formData.append('brand_id', salesbrand);
		formData.append('category_id', salescategory);

		const res = await fetch(`${config.API_URL}/stockReport`, {
			method: 'POST',
			headers: {
				authorization: `Bearer ${accessToken}`,
			},
			body: formData
		});

		const data = await res.json();

		const exportData = data.data.map((product, index) => ({
			"SR": index + 1,
			"Code": product.product_code || '',
			"Name": product.product_name || '',
			"Category": product.categories || '',
			"Brand": product.brand || '',
			"Cost": product.cost || 0,
			"Pack": product.pack || 0,
			"Total Box Qty": product.BoxQuantity || 0,
			"Total Piece Qty": product.PiecesQuantity || 0,
			"Total Amount": parseFloat(product.total || 0).toFixed(2),
		}));

		const ws = XLSX.utils.json_to_sheet(exportData);
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, 'Stock Report');
		XLSX.writeFile(wb, 'Sales_Product_Report.xlsx');
	};

	const searchFormData = () => {
		fetchReport();
	};

	return (
		<div>
			<Header />
			<div className="breadcrumbs">
				<div className="container-fluid">
					<div className="row">
						<div className="col-12">
							<Link to="/Dashboard"><i className="fa fa-home"></i></Link>
							<Link to="/reports/inventory_sales_report">Reports</Link>
							<Link to="/reports/sales_product_report">Stock Report</Link>
						</div>
					</div>
				</div>
			</div>

			<div className="main-container">
				<div className="container-fluid">
					<div className="row align-items-end mb-3">
						<div className="col-md-3">
							<label className="form-label"><b>Date</b></label>
							<CommonDatePicker
								value={dates}
								 showOneCalendar
								// placeholder="DD/MM/YYYY - DD/MM/YYYY"
								onChange={handleDateChange}
								format="dd/MM/yyyy"
								character=" - "
								style={{ width: '100%' }}
							/>
						</div>

						<div className="col-md-3">
							<label className="form-label"><b>Category</b></label>
							<select value={salescategory} onChange={(e) => setSalescategory(e.target.value)} className="form-control">
								<option value="">Select Category</option>
								{categoryOptions.map(opt => (
									<option key={opt.value} value={opt.value}>{opt.label}</option>
								))}
							</select>
						</div>

						<div className="col-md-3">
							<label className="form-label"><b>Brand</b></label>
							<select value={salesbrand} onChange={(e) => setSalesbrand(e.target.value)} className="form-control">
								<option value="">Select Brand</option>
								{brandOptions.map(opt => (
									<option key={opt.value} value={opt.value}>{opt.label}</option>
								))}
							</select>
						</div>

						<div className="col-md-1">
							<button type="button" onClick={searchFormData} className="acceptbtn">
								Submit
							</button>
						</div>

						<div className="col-md-1">
								<button className="acceptbtn" onClick={exportToExcel}>Export</button>
						</div>
					</div>

					{/* Table */}
					<div className="dashboard mt-4">
					
						<div className="verical-scrl-wrapper common-table autoheight-table salesproduct" id="style-3">
						<div className="table-responsive">
							<table ref={salesOrderRef} className="table table-bordered resizable" id="inventorySalesReport" style={{ minWidth: '1200px' }}>
								<thead>
									<tr>
										<th>Sr. No.</th>
										<th>Code</th>
										<th>Name</th>
										<th>Category</th>
										<th>Brand</th>
										<th>Cost</th>
										<th>Pack</th>
										<th>Total Box Qty</th>
										<th>Total Piece Qty</th>
										<th>Total Amount</th>
									</tr>
								</thead>
								<tfoot>
									<tr>
										<th colSpan="7" className="text-end">Total:</th>
										<th id="totalBoxQty">0</th>
										<th id="totalPiecesQty">0</th>
										<th id="totalAmount">0.00</th>
									</tr>
								</tfoot>
								<tbody></tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	
	<Footer />
		</div>
	);
};

export default StockReport;
